import { IRecommendation } from '@/interfaces/recommendation'

export interface SearchState {
  loading: boolean
  searchResults: IRecommendation[]
  searchHistory: string[]
  results: IRecommendation[]
  searchBoxActive?: boolean
  searchTerm?: string
  noMoreResults?: boolean
}

export interface SearchContextProps extends SearchState {
  search: () => void
  setSearchBoxActive: (value: boolean) => void
  seeResults: () => void
  setSearchTerm: (value: string) => void
  setLoading: (value: boolean) => void
  searchMore: () => void
  isOnSearchPage?: boolean
}

export enum SearchActionTypes {
  SET_LOADING = 'SET_LOADING',
  SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS',
  SET_RESULTS = 'SET_RESULTS',
  SET_SEARCH_HISTORY = 'SET_SEARCH_HISTORY',
  RECOVER_SEARCH_HISTORY = 'RECOVER_SEARCH_HISTORY',
  SET_SEARCH_BOX_ACTIVE = 'SET_SEARCH_BOX_ACTIVE',
  SET_SEARCH_TERM = 'SET_SEARCH_TERM',
  SET_MORE_RESULTS = 'SET_MORE_RESULTS',
  SET_NO_MORE_RESULTS = 'SET_NO_MORE_RESULTS',
}

export type SearchAction =
  | { type: SearchActionTypes.SET_LOADING; payload: boolean }
  | { type: SearchActionTypes.SET_SEARCH_RESULTS; payload: IRecommendation[] }
  | { type: SearchActionTypes.SET_SEARCH_HISTORY; payload: string }
  | { type: SearchActionTypes.RECOVER_SEARCH_HISTORY; payload: string[] }
  | { type: SearchActionTypes.SET_RESULTS; payload: IRecommendation[] }
  | { type: SearchActionTypes.SET_SEARCH_BOX_ACTIVE; payload: boolean }
  | { type: SearchActionTypes.SET_SEARCH_TERM; payload: string }
  | { type: SearchActionTypes.SET_MORE_RESULTS; payload: IRecommendation[] }
  | { type: SearchActionTypes.SET_NO_MORE_RESULTS; payload: boolean }

export const INITIAL_SEARCH_STATE: SearchState = {
  loading: false,
  searchResults: [],
  results: [],
  searchHistory: [],
}
